import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    document.getElementById('lead-form')?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { label: 'Lösung', href: '#solution' },
    { label: 'Leistungen', href: '#capabilities' },
    { label: 'Wirtschaftlichkeit', href: '#economics' },
    { label: 'Kontakt', href: '#lead-form' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-sm shadow-sm border-b border-slate-200' 
          : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <a href="#" className="flex items-center">
            <img 
              src="/assets/logo/city-battery-horizontal.svg" 
              alt="city-battery.energy" 
              className="h-[26px] sm:h-[32px] w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6 lg:gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-slate-600 hover:text-cyan-700 transition-colors text-sm font-medium"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden md:block">
            <Button 
              onClick={scrollToForm}
              className="bg-cyan-700 text-white hover:bg-cyan-800 font-medium px-5 lg:px-6 py-2 rounded-lg transition-colors text-sm"
            >
              Projekt anfragen
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-slate-600 hover:text-cyan-700 transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden pb-4 border-t border-slate-100 pt-4">
            <nav className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-slate-600 hover:text-cyan-700 hover:bg-slate-50 transition-colors text-base font-medium py-3 px-2 rounded-lg"
                >
                  {link.label}
                </a>
              ))}
              <Button 
                onClick={scrollToForm}
                className="bg-cyan-700 text-white hover:bg-cyan-800 font-medium px-6 py-3 rounded-lg mt-3 w-full"
              >
                Projekt anfragen
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
